import { render, staticRenderFns } from "./DettaglioAbbonamento.vue?vue&type=template&id=0f053e82&"
import script from "./DettaglioAbbonamento.vue?vue&type=script&lang=js&"
export * from "./DettaglioAbbonamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports